import { render } from "./SingleGallerySection.vue?vue&type=template&id=6e762b93"
import script from "./SingleGallerySection.vue?vue&type=script&lang=js"
export * from "./SingleGallerySection.vue?vue&type=script&lang=js"

import "./SingleGallerySection.vue?vue&type=style&index=0&id=6e762b93&lang=css"
script.render = render

export default script